export default {"src":"/_next/static/media/black_blur.7fc27cd9.svg","height":173,"width":174,"blurWidth":0,"blurHeight":0};